import React, { useEffect, useState } from "react";
import DropDown from "../TPDropDown";
import { t } from "i18next";
import {
	Box,
	FormControl,
	InputLabel,
	MenuItem,
	Tab,
	Tabs,
	Select,
	Stack,
	Button,
  Tooltip,
  Autocomplete,
  TextField
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { api } from "../../../redux/api";
import { inboundTemplateToRcTree } from "../../../utils/rctreeDataConversion";
import SourceTypeInboundDataRenderer from "./SourceTypeInboundDataRenderer";
import { useTranslation } from "react-i18next";
import {
	SOURCE_TYPE,
	CONSTANT_RECORD_TYPE,
	ACTIONS,
	INDEX,
	SYSTEM_SOURCE_NAME,
	IB_SOURCE_NAME,
} from "../../../constants/loopRecordOptions";
import { filterNodes, filterOutNodeTypes } from "../../../utils/utilFunctions";
import { repetitionDropdown } from "../../../constants/constantList";
import JoinInnerIcon from "@mui/icons-material/JoinInner";
import { useCallback } from "react";
import { debounce } from "lodash";
import LightTooltip from "../../../commonComponents/LightTooltip";

const SourceTypeInboundData = ({
	node,
	valuesHandler,
	source,
	allowAllTreeSelection,
	sourceType,
	showInboundTree,
	setShowInboundTree,
	initialSelectCall,
	setSourceType,
	customTreeData,
	isCustomIbTemplate
}) => {
	const { t } = useTranslation();
	const [repetitionIndex, setRepetitionIndex] = useState("");
	const [ibSourceName, setIbSourceName] = useState("");
	const [sourceNameOptions, setSourceNameOptions] = useState(false);
	const [disableSourceName, setDisableSourceName] = useState(true);
	const [treeData, setTreeData] = useState({
		header: [],
		body: [],
		trailer: [],
		dataUpdated: false
	});
	const [repetitionEnabled, setRepetitionEnabled] = useState(false);
	const inboundDependencyTree = useSelector(
		(state) =>
			state.treeData.outbound.leftTree.inboundDependencyTree
	);

	const repetitionIndexOptions = repetitionDropdown.map((ele, index) => {
		return {value: ele?.value, label: t(ele?.text)};
	});


	useEffect(() => {
		if(isCustomIbTemplate) setTreeData(customTreeData)
		else setTreeData({...inboundDependencyTree, dataUpdated: true});
		if (!inboundDependencyTree.templateFound || !isCustomIbTemplate) {
			setIbSourceName('');
			setRepetitionIndex("");
			setDisableSourceName(false);
		}
	}, [inboundDependencyTree]);


	const handleSourceNameSelect = (
		mapname,
		record,
		isFgSelected,
		repeatingNodeSelected,
		initialCall,
		isElementSelected
	) => {
		if (!mapname || isElementSelected) {
			setIbSourceName(
				initialCall
					? node?.MAPNAME || "INTERNAL_TOTAL_RECTYPE_COUNT"
					: isElementSelected ? mapname : "INTERNAL_TOTAL_RECTYPE_COUNT"
			);
			setDisableSourceName(false);
			setRepetitionEnabled(repeatingNodeSelected);
			setRepetitionIndex(
				initialCall ? node?.MAP_REPETITION_INDEX || "CURRENT" : "CURRENT"
			);
			setSourceNameOptions([
				...(isFgSelected
					? [
							<MenuItem key={Math.random() + "0"} value={"INTERNAL_ALL"}>
								{t("INTERNAL_ALL")}
							</MenuItem>,
					  ]
					: []),
				...(isElementSelected ? [
					<MenuItem key={Math.random() + "0.5"} value={mapname}>
						{mapname}
					</MenuItem>,
				]: []
				),
				<MenuItem
					key={Math.random() + "1"}
					value={"INTERNAL_TOTAL_RECTYPE_COUNT"}
				>
					{t("INTERNAL_TOTAL_RECTYPE_COUNT")}
				</MenuItem>,
				<MenuItem
					key={Math.random() + "2"}
					value={"INTERNAL_CURRENT_RECTYPE_COUNT"}
				>
					{t("INTERNAL_CURRENT_RECTYPE_COUNT")}
				</MenuItem>,
			]);
		} else {
			setRepetitionEnabled(repeatingNodeSelected);
			setRepetitionIndex(
				initialCall ? node?.MAP_REPETITION_INDEX || "CURRENT" : "CURRENT"
			);
			setIbSourceName(mapname);
			setDisableSourceName(true);
			setSourceNameOptions([
				<MenuItem key={Math.random() + "0"} value={mapname}>
					{mapname}
				</MenuItem>,
			]);
		}
	};

	useEffect(() => {
		if (
			(node?.PARENT || node?.SOURCE_PARENT) &&
			node?.MAPNAME &&
			node?.RECORD_TYPE
		) {
			setIbSourceName(node?.MAPNAME);
			setRepetitionIndex(node?.MAP_REPETITION_INDEX || "CURRENT");
		}
	}, [node?.key]);

	const debounceChangeHandler = useCallback(debounce(valuesHandler, 400), [
		node?.key,
	]);

	return (
		<>
			{repetitionEnabled ? (
				<Autocomplete
					sx={{marginBottom: '10px'}}
					size='small'
					variant='outlined'
					className='width-100'
					options={repetitionEnabled ? repetitionIndexOptions : []}
					inputValue={repetitionEnabled ? repetitionIndex : ""}
					disabled={!repetitionEnabled}
					name='repetitionIndex'
					label={t("LBL_REPETITION_INDEX")}
					value={repetitionEnabled ? repetitionIndex : ""}
					onChange={(e, newValue) => {
						
						setRepetitionIndex(newValue?.value || "");
						debounceChangeHandler({
							PARENT: node?.PARENT,
							RECORD_TYPE: node?.RECORD_TYPE,
							MAPNAME: node?.MAPNAME,
							MAP_REPETITION_INDEX:newValue?.value || "",
							FIELDTYPE: node?.FIELDTYPE || false,
							PATTERN: node?.PATTERN || false,
							SOURCE_REPEATING_FIELD: repetitionEnabled ? "TRUE" : "FALSE"
						});
					}}
					renderInput={(params) => (
						<TextField
							autoComplete={"off"}
							{...params}
							onChange={(e, newValue) => {
								setRepetitionIndex(e?.target?.value || "");
								debounceChangeHandler({
									PARENT: node?.PARENT,
									RECORD_TYPE: node?.RECORD_TYPE,
									MAPNAME: node?.MAPNAME,
									MAP_REPETITION_INDEX: e?.target?.value || "",
									FIELDTYPE: node?.FIELDTYPE || false,
									PATTERN: node?.PATTERN || false,
									SOURCE_REPEATING_FIELD: repetitionEnabled ? "TRUE" : "FALSE"
								});
							}}
							label={t("LBL_REPETITION_INDEX")}
						/>
					)}
				/>
			) : <></>}

			<Stack direction={"row"} spacing={"10px"}>
				<DropDown
					disabled={disableSourceName}
					label={t("LBL_SOURCE_NAME")}
					options={sourceNameOptions}
					value={ibSourceName}
        	onChange={(e) => {
						setIbSourceName(e?.target.value);
						valuesHandler({
							PARENT: node?.PARENT,
							RECORD_TYPE: node?.RECORD_TYPE,
							MAPNAME: e.target.value,
							MAP_REPETITION_INDEX: repetitionEnabled
								? repetitionIndex
								: undefined,
							FIELDTYPE: node?.FIELDTYPE || false,
							PATTERN: node?.PATTERN || false
						}, "INBOUND_DATA");
					}}
      	/>

				{/* commenting this out because the label looks weird when no value is passed. */}
				{/* <FormControl className='width-100'>
					<InputLabel >{t("LBL_SOURCE_NAME")}</InputLabel>
					<Select
						className='width-100'
						name='ibSourceName'
						label={t("LBL_SOURCE_NAME")}
						value={ibSourceName}
						disabled={disableSourceName}
						size="small"
						onChange={(e) => {
							setIbSourceName(e?.target.value);
							valuesHandler({
								PARENT: node?.PARENT,
								RECORD_TYPE: node?.RECORD_TYPE,
								MAPNAME: e.target.value,
								REPITITION_INDEX: repetitionEnabled
									? repetitionIndex
									: undefined,
								FIELDTYPE: node?.FIELDTYPE || false,
								PATTERN: node?.PATTERN || false
							}, "INBOUND_DATA");
						}}
					>
						{sourceNameOptions}
					</Select>
				</FormControl> */}
				
        <LightTooltip title={t(showInboundTree ? "HOVER_MSSG_HIDE_INBOUND_TREE" : "HOVER_MSSG_SHOW_INBOUND_TREE")}>
          <Button 
            variant='outlined' 
            sx={{minWidth: "38px"}} 
            size='small'
            onClick={() => setShowInboundTree(prev => !prev)}
            >
            <JoinInnerIcon fontSize='medium' />
          </Button>
        </LightTooltip>
			</Stack>

			<SourceTypeInboundDataRenderer
				allowAllTreeSelection={allowAllTreeSelection}
				source={source}
				node={node}
				treeData={treeData}
				handleSourceNameSelect={handleSourceNameSelect}
				valuesHandler={valuesHandler}
				isLoading={inboundDependencyTree?.isLoading}
				fileType={inboundDependencyTree?.templateHeader?.FILETYPE}
				setRepetitionEnabled={setRepetitionEnabled}
				setDisableSourceName={setDisableSourceName}
				setShowInboundTree={setShowInboundTree}
				showInboundTree={showInboundTree}
				initialSelectCall={initialSelectCall}
				setSourceType={setSourceType}
				sourceType={sourceType}
			/>
		</>
	);
};

export default SourceTypeInboundData;
